import { useEffect, useState } from "react";
import { ALL_BLOCKED, patientSensitiveDataService, SensitiveDataFlags, SensitiveGroup } from "../services/patientSensitiveDataService";

/**
 * Flags de dados sensíveis da sessão (RN-112q). Devolve `null` enquanto carrega — a tela não
 * sinaliza nada até saber; falha de rede cai para tudo bloqueado (a API mascara de qualquer jeito).
 */
export function useSensitiveDataAccess(): {
  flags: SensitiveDataFlags | null;
  /** true só quando a resposta chegou e o grupo está bloqueado para o perfil da sessão */
  restricted: (group: SensitiveGroup) => boolean;
} {
  const [flags, setFlags] = useState<SensitiveDataFlags | null>(null);

  useEffect(() => {
    let alive = true;
    patientSensitiveDataService.mine()
      .then((f) => { if (alive) setFlags(f); })
      .catch(() => { if (alive) setFlags(ALL_BLOCKED); });
    return () => { alive = false; };
  }, []);

  return {
    flags,
    restricted: (group) => flags !== null && !flags[group],
  };
}
